<template>
    <div class="main-content">
        <!-- <multiselect
            id="select-team"
            v-model="teams"
            :options="teamNames"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            :option-height="40"
            :show-labels="false"
            placeholder="Escolha a equipe"
            track-by="value"
            label="text"
        >
            <template slot="selection" slot-scope="{ values }">
                <span class="multiselect__single" v-if="values.length">{{ values.length }} selecionados</span>
            </template>
            <template slot="option" slot-scope="props">
                <div class="option__desc">
                    <span class="option__title">{{ props.option }}</span>
                </div>
            </template>
        </multiselect> -->
        <b-card no-body class="shadow-none bg-transparent">
            <date-picker></date-picker>
        </b-card>
        <list
            :columns="columns"
            :rows="records"
            :select-options="{
                enabled: false,
            }"
            :pagination-options="{
                perPage: 20,
            }"
            :loading="loading"
            class="mt-3"
        />
    </div>
</template>

<script>

import api from '@/api/api'
import auth from '@/firebase/auth'
// import Multiselect from 'vue-multiselect'
// require('vue-multiselect/dist/vue-multiselect.min.css')

export default {
    name: 'ScoreEvolutionReportByTeams',
    components: {
        DatePicker: () => import('@/components/datePicker'),
        List: () => import('@/components/List/List'),
        // Multiselect,
    },
    data () {
        return {
            dates: [],
            loading: false,
            records: [],
            teams: [],
            columns: [
                {
                    label: 'Equipe',
                    field: 'name',
                },
                {
                    label: 'Incrível',
                    field: 'responseCounterByIndex.3',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Feliz',
                    field: 'responseCounterByIndex.2',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Regular',
                    field: 'responseCounterByIndex.1',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Infeliz',
                    field: 'responseCounterByIndex.0',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Média (0 a 100)',
                    field: 'average',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Participação %',
                    field: 'percentage',
                    type: 'percentage',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
                {
                    label: 'Nº de Pesquisas',
                    field: 'totalResearches',
                    thClass: 'text-center',
                    tdClass: 'text-center',
                },
            ],
        }
    },
    methods: {
        loadData () {
            this.loading = true
            auth
                .currentUser
                .getIdToken()
                .then((token) => {
                    api
                        .get('/reports/score-evolution-by-teams', {
                            params: {
                                range: this.range,
                            },
                            headers: {
                                token,
                            },
                        })
                        .then(response => {
                            this.loading = false

                            if (!response.data || !response.data.length) return

                            this.records = response.data
                        })
                })
                .catch(err => console.log(err))
        },
    },
    computed: {
        range () {
            return this.$store.getters['dashboard/range']
        },
    },
    watch: {
        range: {
            immediate: true,
            handler () {
                this.loadData()
            },
        },
    },
}

</script>
